import _ from 'lodash';


export class BaseReCalc {
    constructor (object) {
        this.acresChanged = false;
        this.object = object;
    }

    get canUpdateRate () {
        return this.object.acres >= 0 && this.object.rate > 0;
    }

    rate () {
        if (!this.canUpdateRate) {
            return;
        }
        this.object.quantity = _.round((this.object.acres * this.object.rate) / 2000, 3);
        this._nutrients();
    }

    acres () {
        this.object.acres = _.round(this.object.acres, 3);
        this.rate();
        this.acresChanged = !this.acresChanged;
    }

    quantity () {
        this.object.quantity = _.round(this.object.quantity, 3);
        this.object.acres = _.round((this.object.quantity * 2000) / this.object.rate, 3);
        if (_.isNaN(this.object.acres)) {
            this.object.acres = 0;
        }
        this.acresChanged = !this.acresChanged;
    }

    _nutrients () { }

}



// WEBPACK FOOTER //
// ./src/app/common/calculation.js